"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BOND_SUNDAY = exports.MAX_DAYS_IN_MONTH = exports.FIRST_DAY_OF_MONTH = exports.DAYS_IN_WEEK = exports.HOURS_IN_DAY = exports.MINUTES_IN_HOUR = exports.SECONDS_IN_MINUTE = exports.ROUNDING_THRESHOLD = exports.DEFAULT_DATE_RANGE_TEMPLATE_START_END = exports.DEFAULT_DATE_RANGE_TEMPLATE = exports.DAYS_OF_WEEK_TO_BOND_DAYS_OF_WEEK = exports.DEFAULT_TIMEZONE = exports.TIME_THRESHOLD_MS = exports.DEFAULT_LANGUAGE_REGION_CODE = exports.DEFAULT_FORMAT = void 0;
const enums_1 = require("./enums");
exports.DEFAULT_FORMAT = enums_1.DateTimeFormats.DATE_TIME_FULL_WITH_WEEKDAY;
exports.DEFAULT_LANGUAGE_REGION_CODE = enums_1.LanguageRegionCodes.EN_US;
exports.TIME_THRESHOLD_MS = 1000;
exports.DEFAULT_TIMEZONE = 'UTC';
exports.DAYS_OF_WEEK_TO_BOND_DAYS_OF_WEEK = [8, 2, 3, 4, 5, 6, 7]; // Sunday is 8 because it is the first day of the week in the Bond market
exports.DEFAULT_DATE_RANGE_TEMPLATE = '{{start}} - {{end}}, {{year}}';
exports.DEFAULT_DATE_RANGE_TEMPLATE_START_END = '{{start}} - {{end}}';
exports.ROUNDING_THRESHOLD = 0.5;
exports.SECONDS_IN_MINUTE = 60;
exports.MINUTES_IN_HOUR = 60;
exports.HOURS_IN_DAY = 24;
exports.DAYS_IN_WEEK = 7;
exports.FIRST_DAY_OF_MONTH = 1;
exports.MAX_DAYS_IN_MONTH = 31;
exports.BOND_SUNDAY = 8;
//# sourceMappingURL=constants.js.map